import classNames from 'classnames';
import React from 'react';

type Props = {
  children?: React.ReactNode,
  className?: string,
  align?: 'left' | 'right'
};

type DefaultProps = Required<Pick<Props, 'align'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class ToolbarGroup extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    align: 'left'
  };

  override render (): React.ReactNode {
    const { children, className, align } = (this.props as PropsWithDefaults);

    return (
      <div className={classNames(align === 'right' ? 'esko_toolbarright' : 'esko_toolbarleft', className)}>
        {children}
      </div>
    );
  }
}

export default ToolbarGroup;
